import React, { useEffect, useLayoutEffect, useState } from "react";
import styles from "./RightBar.module.css";
// import { getProofPdfApi } from "../api";
import { compileXmlApi, getProofPdfFileApi, update_project_file_Api } from "../dashboardapi";
import { Spinner } from "@chakra-ui/react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

function RightBar(props) {
  const [active, setActive] = useState("");
  const projectId = props.projectId;
  const projectDetails = props.projectDetails;
  const hideTools = projectDetails.is_internal;
  const projectFiles = props.projectfiles;
  const curFileObj = projectFiles.filter(e => e.name === props.current_file)[0]
  const toast = props.toast;
  // console.log(props);

  // const url = useLocation();
  const navigate = useNavigate();
  const location = useLocation();
  // console.log(location.pathname);
  // {
  //   pathname: "/dashboard",
  //   search: "?tab=1",
  //   hash: "",
  //   state: null,
  //   key: "abc123"
  // }


  // useLayoutEffect(() => {
  //   handlehash()
  // }, [])

  useEffect(() => {
    handlehash()
  }, [location.hash, projectDetails])

  const handlehash = () => {
    const hash = location.hash.toLowerCase();
    console.log("hash", hash);
    if (hash === "#xml") {
      setActive("xml")
      // xml();
    } else if (hash === "#proofpdf") {
      getProofPdf()
    } else if (hash === "#rawlog") {
      raw()
    } else if (hash === "#suggestions") {
      EditChanges()
    } else if (hash === "#pdf" || hash === "#correction") {
      corrections()
    } else {
      corrections()
    }
  }

  const getProofPdf = async () => {
    var result = await getProofPdfFileApi(projectId, curFileObj?.file_uuid);
    if (result.data) {
      props.control((prevState) => ({
        ...prevState,
        view: "proofPdf",
        proofPdfData: "data:application/pdf;base64," + result.data.pdf,
      }));
    } else {
      props.control((prevState) => ({
        ...prevState,
        view: "proofPdf",
        proofPdfData: result.error.error,
      }));
      toast({
        title: "Failed to load PDF",
        description: result.error.error,
        status: "error",
        isClosable: true,
        duration: 2000
      })
    }
    setActive("proofpdf");
  };

  const corrections = () => {
    hideTools === true ? navigate("#correction") : navigate("#pdf")
    props.control((prevState) => ({
      ...prevState,
      view: "pdf",
    }));
    hideTools ? setActive("correction") : setActive("pdf");
  };

  // const error = () => {
  //   props.control((prevState) => ({
  //     ...prevState,
  //     view: "error",
  //   }));
  //   setActive("error");
  // };

  const raw = () => {
    props.control((prevState) => ({
      ...prevState,
      view: "raw",
    }));
    setActive("raw");
  };

  const EditChanges = () => {
    props.control((prevState) => ({
      ...prevState,
      view: "suggestions",
    }));
    setActive("suggestions");
  };

  // const correction = () => {
  //   props.control((prevState) => ({
  //     ...prevState,
  //     view: "correction",
  //   }));
  //   setActive("correction");
  // };

  // const queries = () => {
  //   props.control((prevState) => ({
  //     ...prevState,
  //     view: "queries",
  //   }));
  //   setActive("queries");
  // };


  const xml = async () => {
    navigate("#xml")
    let response = await update_project_file_Api(projectId, curFileObj?.file_uuid, curFileObj?.filename, props.tex);

    if (response.data) {
      toast({
        title: "Saving Tex.",
        description: "Save successfull.",
        status: "success",
        duration: 1000,
      });
      toast({
        title: "Generating XML",
        description: "XML compiling inprogress.",
        status: "info",
        duration: null,
        icon: (
          <Spinner
            thickness="4px"
            emptyColor="gray.200"
            color="blue.500"
            size="sm"
          />
        ),
      });
      var result = await compileXmlApi(projectId, curFileObj.file_uuid);
      toast.closeAll();
      toast({
        title: "Success.",
        description: "Generating XML successfull.",
        status: "success",
        duration: 2000,
      });
      props.control((prevState) => ({
        ...prevState,
        view: "xml",
        xml: result.data?.xml,
      }));
      setActive("xml");
    };
  }


  return (
    <div className={styles.right_bar_container}>
      <div
        onClick={() => { corrections() }}
        className={`${(hideTools ? active === "correction" : active === "pdf") ? styles.current : styles.disabled
          } ${styles.right_bar_menu}`}
      >
        {!hideTools ? "PDF" : "Correction"}
      </div>
      <div
        hidden={!hideTools}
        onClick={() => navigate("#proofpdf")}
        className={`${active === "proofpdf" ? styles.current : styles.disabled
          } ${styles.right_bar_menu}`}
      >
        Proof
      </div>
      <div
        onClick={() => xml()}
        className={`${active === "xml" ? styles.current : styles.disabled} ${styles.right_bar_menu
          }`}
      >
        XML
      </div>
      {/* <div
        onClick={() => error()}
        className={`${active === "error" ? styles.current : styles.disabled} ${styles.right_bar_menu
          }`}
      >
        Error Log
      </div> */}
      <div
        onClick={() => {
          raw();
          navigate("#rawlog")
        }}
        className={`${active === "raw" ? styles.current : styles.disabled} ${styles.right_bar_menu
          }`}
      >
        Raw Log
      </div>

      <div
        onClick={() => {
          EditChanges();
          navigate("#suggestions")
        }}
        className={`${active === "suggestions" ? styles.current : styles.disabled} ${styles.right_bar_menu
          }`}
      >
        Suggestions
      </div>
      {/* <div
        onClick={() => correction()}
        className={`${active === "correction" ? styles.current : styles.disabled} ${styles.right_bar_menu
          }`}
      >
        Corrections
      </div> */}
      {/* <div
        onClick={() => queries()}
        className={`${active === "queries" ? styles.current : styles.disabled} ${styles.right_bar_menu
          }`}
      >
        Queries
      </div> */}
    </div>
  );
}

const mapStateToProps = (state) => ({
  tex: state.uploadTex.tex,
  isChecked: state.toolStyles.isChecked,
});

export default connect(mapStateToProps)(RightBar);
